import React from "react";
import "./WildlifeSafariTrip.css";
import AfricanSavannahSafari from "../../assets/AfricanSavannahSafari.png";
import RanthamboreTigerSafari from "../../assets/RanthamboreTigerSafari.png";
import KazirangaWildlifeExpedition from "../../assets/KazirangaWildlifeExpedition.png";
import AmazonRainforestJourney from "../../assets/AmazonRainforestJourney.png";
import JimCorbettJungleSafari from "../../assets/JimCorbettJungleSafari.png";
import SerengetiMigrationTour from "../../assets/SerengetiMigrationTour.png";
import { useNavigate } from "react-router-dom";
const wildlifeTrips = [
  {
    title: "African Savannah Safari",
    image: AfricanSavannahSafari,
    description:
      "Explore the vast African savannah filled with majestic lions, elephants, and giraffes roaming freely. Enjoy guided jeep safaris, breathtaking sunsets, and unforgettable wildlife encounters in this thrilling natural adventure experience.",
    link: "/tour-package-data",
  },
  {
    title: "Ranthambore Tiger Safari",
    image: RanthamboreTigerSafari,
    description:
      "Experience the excitement of spotting royal Bengal tigers in Ranthambore National Park. Discover dense forests, ancient ruins, and diverse wildlife while enjoying guided safaris in this remarkable jungle setting.",
    link: "/tour-package-data",
  },
  {
    title: "Kaziranga Wildlife Expedition",
    image: KazirangaWildlifeExpedition,
    description:
      "Visit Kaziranga National Park to witness rare one horned rhinoceroses and vibrant bird species. Enjoy jeep and elephant safaris through lush grasslands and wetlands during this extraordinary wildlife adventure.",
    link: "/tour-package-data",
  },
  {
    title: "Amazon Rainforest Journey",
    image: AmazonRainforestJourney,
    description:
      "Explore the rich biodiversity of the Amazon rainforest filled with exotic animals and lush greenery. Experience river cruises, guided jungle walks, and fascinating wildlife encounters in this adventurous expedition.",
    link: "/tour-package-data",
  },
  {
    title: "Jim Corbett Jungle Safari",
    image: JimCorbettJungleSafari,
    description:
      "Discover the beauty of Jim Corbett National Park while spotting deer, elephants, and elusive tigers. Enjoy thrilling jeep safaris, peaceful forest surroundings, and scenic landscapes during this memorable wildlife trip.",
    link: "/tour-package-data",
  },
  {
    title: "Serengeti Migration Tour",
    image: SerengetiMigrationTour,
    description:
      "Witness the spectacular Great Migration in Serengeti as thousands of wildebeest and zebras travel across vast plains. Experience dramatic wildlife moments, stunning scenery, and guided safari adventures.",
    link: "/tour-package-data",
  },
];

const WildlifeSafariTrip = () => {
  const navigate=useNavigate()
  return (
    <div className="wildlife-container">
      <h2 className="wildlife-title">Wildlife Safari Packages</h2>

      <div className="wildlife-grid">
        {wildlifeTrips.map((trip, index) => (
          <div
            className="wildlife-card"
            key={index}
            onClick={() =>
              navigate(trip.link, {
                state: { title: trip.title },
              })
            }
          >
            <img src={trip.image} alt={trip.title} />
            <div className="wildlife-content">
              <h3>{trip.title}</h3>
              <p>{trip.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WildlifeSafariTrip;
